








































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { CrudService } from '@/data/services/crud.service';
import { Tipologiaservizio } from '@/data/models/tipologiaservizio.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class EditTipologiaservizio extends Vue {
	@Prop() tipologiaservizio?: Tipologiaservizio;

	@Inject('CrudService') tipologiaservizioCrudService!: CrudService<Tipologiaservizio>;

	newTipologiaservizio!: Tipologiaservizio;

	constructor() {
		super();
		this.newTipologiaservizio = new Tipologiaservizio();
	}

	beforeMount() {
		if (this.tipologiaservizio) {
			if (this.tipologiaservizio.id) {
				// edit
				this.loadTipologiaservizio(this.tipologiaservizio.id);
			} else {
				this.newTipologiaservizio = new Tipologiaservizio();
			}
		}
	}

	loadTipologiaservizio(id: number) {
		this.tipologiaservizioCrudService
			.getEntity(Tipologiaservizio, 'tipologiaservizio', id)
			.then(result => {
				this.newTipologiaservizio = result;
			})
			.catch(error => {
				this.$buefy.notification.open({
					message: error.msg,
					type: 'is-danger'
				});
			});
	}

	submit() {
		this.$emit('submit', this.newTipologiaservizio);
	}

	get color(): any {
		return {
			hex: this.newTipologiaservizio.color || '',
		};
	}

	set color(value: any) {
		this.$set(this.newTipologiaservizio, 'color', value.hex);
	}

}
